import { createContext, type ReactNode } from 'react';

import { DEFAULT_TRACKING_CONFIG } from './trackingConfig';
import type { TrackingContextValue } from './types';

export const TrackingContext = createContext<TrackingContextValue>(DEFAULT_TRACKING_CONFIG);

interface TrackingProviderProps {
  value: TrackingContextValue;
  children: ReactNode;
}

export function TrackingProvider({ value, children }: TrackingProviderProps) {
  return <TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>;
}
